export const APPLICATION_READ = 'application.read';
export const APPLICATION_WRITE = 'application.write';
export const DASHBOARD_READ = 'dashboard.read';
export const ENTITY_DOC_READ = 'entity.doc.read';
export const ENTITY_DOC_WRITE = 'entity.doc.write';
export const ENTITY_READ = 'entity.read';
export const ENTITY_WRITE = 'entity.write';
export const LOANS_ACH_DOCS_READ = 'loans.ach.docs.read';
export const LOANS_ACH_DOCS_WRITE = 'loans.ach.docs.write';
export const LOANS_ACH_READ = 'loans.ach.read';
export const LOANS_ACH_WRITE = 'loans.ach.write';
export const LOANS_DRAW_DOCS_READ = 'loans.draw.docs.read';
export const LOANS_DRAW_DOCS_WRITE = 'loans.draw.docs.write';
export const LOANS_DRAW_READ = 'loans.draw.read';
export const LOANS_DRAW_WRITE = 'loans.draw.write';
export const LOANS_PAYOFF_READ = 'loans.payoff.read';
export const LOANS_PAYOFF_WRITE = 'loans.payoff.write';
export const LOANS_READ = 'loans.read';
export const LOANS_WRITE = 'loans.write';
export const MYDOCS_READ = 'mydocs.read';
export const MYDOCS_WRITE = 'mydocs.write';
export const OWNER = 'owner';
export const PAYMENTS_READ = 'payments.read';
export const PAYMENTS_WRITE = 'payments.write';
export const PLAID_READ = 'plaid.read';
export const PLAID_WRITE = 'plaid.write';
export const SETTINGS_READ = 'settings.read';
export const SETTINGS_WRITE = 'settings.write';



// WEBPACK FOOTER //
// ./src/libs/permissions_list.js